import Turbolinks from "turbolinks";

import ChatRender from "./chat_render";
import ChatDocumentManager from "./chat_document_manager";
import initializeChatChannel from "../channels/chat_channel";
import ChatHandler from "./chat_handler";
import TypingReceivingManager from "./typing_receiving_manager";
import TypingSendingManager from "./typing_receiving_manager";
import scrollChatDown from "./scroll_chat_down";

$(document).on("turbolinks:load", function () {
  let container = document.getElementById("chat-container");
  if (container) {
    scrollChatDown();
    initializeChat(container);
  } else {
    disconnectChat();
  }
});

// comment-actions icons callbacks
// These are not strictly necessary, as the confirmation also happens
// over the WebSocket connection.
// But they slightly improve responsiveness.
$(document).on("ajax:success", ".action-pin, .action-save", (e) =>
  e.target.classList.toggle("active")
);

$(document).on("ajax:success", ".action-delete", (e) => {
  const comment = $(e.target).parents(".comment-item");
  comment.remove();
});

$(document).on("ajax:success", ".action-recover", () => {
  Turbolinks.clearCache();
  Turbolinks.visit(window.location);
});

function initializeChat(container) {
  let chatId = container.dataset.chatId;
  let shipmentId = container.dataset.shipmentId;
  console.log("connecting chat");
  App.currentChat = new Chat(chatId, shipmentId);
}

function disconnectChat() {
  if (App.currentChat) {
    console.log("disconnecting chat");
    App.currentChat.chatRoom.unsubscribe();
    delete App.currentChat;
  }
}

class Chat {
  constructor(chatId, shipmentId) {
    this.chatId = chatId;
    this.shipmentId = shipmentId;

    this.chatRenderer = new ChatRender(this);
    this.chatRoom = initializeChatChannel(this);
    this.chatDocumentManager = new ChatDocumentManager(shipmentId);
    this.chatHandler = new ChatHandler(this);
    this.typingReceivingManager = new TypingReceivingManager(this.chatRoom);
    this.typingSendingManager = new TypingSendingManager(this.chatRoom);
  }
}
